<svg width="16" height="13" viewBox="0 0 16 13" fill="none" stroke="#000000"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M1 7.03101L5 11.031L15 1.03101" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
